import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

interface IRemoveWorkerFromInterventionSuccessAction {
  id: number;
  intervention_id?: number;
}

function removeWorkerSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IRemoveWorkerFromInterventionSuccessAction>,
) {
  if (draft.getDetails.values) {
    draft.getDetails.values = {
      ...draft.getDetails.values,
      worker_ids: draft.getDetails.values.worker_ids?.filter(
        id => id !== action.payload.id,
      ),
    };
  }
}

export default removeWorkerSuccess;
